import { webServiceCall } from "../../services/pantherService";

function getOrCreateBrowserToken() {
  let token = localStorage.getItem("browser_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("browser_token", token);
  }
  return token;
}

function getBrowserMetadata() {
  return {
    ua: navigator.userAgent,
    lang: navigator.language,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: `${window.screen.width}x${window.screen.height}`,
  };
}

const BROWSER_INFO = JSON.stringify({
  token: getOrCreateBrowserToken(),
  meta: getBrowserMetadata(),
});

export const getClientInfo = async (guid) => {
  try {
    const result = await webServiceCall("ClientInfo", {
      GUId: guid,
    });

    if (result && result.length > 0) {
      const clientData = result[0];
      localStorage.setItem("clientData", JSON.stringify(clientData));
      return clientData;
    }

    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const login = async (guid, email, password) => {
  try {
    const result = await webServiceCall("PaxLogin", {
      GUId: guid,
      email,
      password,
      browserInfo: BROWSER_INFO,
    });

    if (result === "Error incorrect email or password!") return "Error";
    if (result === "A 2 factor code has been sent to your email!") return "2FA";
    if (result === "Must change password!") return "ChangePassword";

    localStorage.setItem("paxData", JSON.stringify(result));
    return JSON.stringify(result);
  } catch (err) {
    console.error("Login failed:", err);
    return "Error";
  }
};

// --- Two Factor ---
export const twoFactor = async (guid, email, password, code) => {
  try {
    const resultText = await webServiceCall("TwoFactor", {
      GUId: guid,
      email,
      password,
      browserInfo: BROWSER_INFO,
      twoFactorCode: code,
    });

    if (
      typeof resultText === "string" &&
      resultText.toLowerCase().includes("incorrect")
    ) {
      return "Error";
    }

    return resultText;
  } catch (err) {
    console.error("TwoFactor failed:", err);
    return "Error";
  }
};

// --- Update Password ---
export const updatePassword = async (guid, email, oldPassword, newPassword) => {
  try {
    const resultText = await webServiceCall("UpdatePassword", {
      GUId: guid,
      email,
      oldPassword,
      newPassword,
    });

    if (resultText?.toLowerCase().includes("incorrect")) return "Error";

    return "Success";
  } catch (err) {
    console.error("UpdatePassword failed:", err);
    return "Error";
  }
};

// --- Forgot Password ---
export const forgotPassword = async (guid, email) => {
  try {
    const resultText = await webServiceCall("ForgotPassword", {
      GUId: guid,
      email,
    });

    return resultText?.toLowerCase().includes("ok!") ? "Ok!" : "Error";
  } catch (err) {
    console.error("ForgotPassword failed:", err);
    return "Error";
  }
};

// --- Register ---
export const register = async (guid, email) => {
  try {
    const resultText = await webServiceCall("RegisteredUserNewPassword", {
      GUId: guid,
      email,
    });

    if (resultText?.toLowerCase().includes("ok!")) return "Ok!";

    return "Account has either already been activated or there are multiple accounts with this email.";
  } catch (err) {
    console.error("Register failed:", err);
    return "Error";
  }
};
